module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 4H14V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v28c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8.18 13l-5.174 6.652c-.358.468-.936.462-1.292-.008L10.18 17c-.358-.47-.164-1 .43-1H14v-4.998c0-.552.448-1.002 1-1.002h2c.552 0 1 .45 1 1.002V16h3.39c.594 0 .788.528.43 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/download-folder-1.js
// module id = 1121
// module chunks = 14